export type IOpenFileSystemBrowser = (url: string) => Window;

export function openFileSystemBrowser(url: string): Window {
  const params = 'width=600,height=500,resizable=yes,scrollbars=no,status=no';
  const name = `filesystemBrowser${Math.round(Math.random() * 10000)}`;
  return window.open(url, name, params) as Window;
}
